import React from 'react';
import { NumberInput, Typography } from '@thimble/core-lib';
import type { NumberInputProps } from '@thimble/core-lib';

const { Text } = Typography;

const ICNumberInput: React.ForwardRefExoticComponent<
  Omit<NumberInputProps, 'label'> & {
    label: [string, React.ReactNode];
  } & React.RefAttributes<HTMLInputElement>
> = React.forwardRef(({ label, ...rest }, ref) => {
  return (
    <div>
      <div>
        {
          <Text preset="body" color="black">
            {label[0]}
          </Text>
        }
        {label[1]}
      </div>
      <NumberInput {...rest} ref={ref} />
    </div>
  );
});

export default ICNumberInput;
